import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import MapIcon from "../../../../images/mapTab.svg";
import DashboardIcon from "../../../../images/dashboardTab.svg";
import ExplorerIcon from "../../../../images/explorerTab.svg";

import FastRewindIcon from "@mui/icons-material/FastRewind";
import FastForwardIcon from "@mui/icons-material/FastForward";
import RefreshIcon from "@mui/icons-material/Refresh";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import dayjs from "dayjs";

import AMTDateBox from "../../../../components/AMTDateBox";

import { IconButton } from "@mui/material";

import { updateRequest } from "../../../../store/actions/deviceDashboard";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "antd";
import DOMPurify from 'dompurify';

function DeviceDashboardHeader(props) {
  const { id, pageTitle, parentRef } = props;
  const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(updateRequest({selectedDateTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss")}));
  },[])
  
  const isFullScreenMode = useSelector(
    (state) => state.deviceDashboard.isFullScreenMode
  );
  const isDeviceDataLoading = useSelector(
    (state) => state.deviceDashboard.isLoading.deviceData
  );
  const defaultDisplayOpt = useSelector(
    (state) => state.deviceDashboard.displayOpt
  );
  const defaultTime = useSelector(
    (state) => state.deviceDashboard.resolutionTime
  );
  const defaultDate = useSelector(
    (state) => state.deviceDashboard.selectedDateTime
  );

  const currentTime = new Date(defaultDate);

  const updateDateTime = (res) => {
    const { date, time, displayOpt } = res;
    const today = new Date();
    dispatch(
      updateRequest(
        displayOpt === "most_recent"
          ? {
              displayOpt,
              resolutionTime: time,
              selectedDateTime: `${today.getFullYear()}-${
                (today.getMonth() + 1).toString()
                .padStart(2, "0")
              }-${today
                .getDate()
                .toString()
                .padStart(2, "0")}T${today.toLocaleTimeString({
                hour12: false,
              })}`,
              isRefresh: true,
            }
          : {
              displayOpt,
              resolutionTime: time,
              selectedDateTime: date,
              isRefresh: true,
            }
      )
    );
  };
  const handleFullScreen = () => {
    const elem = parentRef.current;

    if (parentRef?.current) {
      if (document.fullscreenElement) document.exitFullscreen();
      else elem.requestFullscreen();

      dispatch(
        updateRequest({
          isFullScreenMode: !isFullScreenMode,
        })
      );
    }
  };
  // const handleBackward = () => {
  //   currentTime.setTime(currentTime.getTime() - parseInt(defaultTime));
  //   console.log("handleBackward post",defaultTime, currentTime);
  //   dispatch(
  //     updateRequest({
  //       selectedDateTime: currentTime,
  //       isRefresh: true,
  //     })
  //   );
  // };
  // const handleForward = () => {
  //   const nextTime = currentTime.getTime()+parseInt(defaultTime);
  //   currentTime.setTime(nextTime);
  //   console.log("handleForward post",defaultTime, currentTime, nextTime);
  //   dispatch(
  //     updateRequest({
  //       selectedDateTime: currentTime,
  //       isRefresh: true,
  //     })
  //   );
  // };
  const handleRefresh = () => {
    const today = new Date();
    dispatch(
      updateRequest({
        selectedDateTime: `${today.getFullYear()}-${
          (today.getMonth() + 1).toString()
          .padStart(2, "0")
        }-${today
          .getDate()
          .toString()
          .padStart(2, "0")}T${today.toLocaleTimeString({
          hour12: false,
        })}`,
        isRefresh: true,
      })
    );
  };
  return (
    <div className="view-device-dashboard-full">
      {isDeviceDataLoading && <Skeleton paragraph={{ rows: 1 }} />}
      {!isDeviceDataLoading && (
        <>
          <div className="d-flex flex-sm-column flex-md-row justify-content-between align-items-center view-device-dashboard-tab-container">
            <div className="view-device-dashboard-tab-text">
              Dashboard - {pageTitle} Details
            </div>
            <div className="view-device-dashboard-tabs">
              <Link to={`/devices/${DOMPurify.sanitize(id)}/map`}>
                <img src={MapIcon} alt="MapIcon" />
              </Link>
              <Link className="active" to={`/devices/${DOMPurify.sanitize(id)}/dashboard`}>
                <img src={DashboardIcon} alt="MapIcon" />
              </Link>
              <Link to={`/devices/${DOMPurify.sanitize(id)}/explorer`}>
                <img src={ExplorerIcon} alt="MapIcon" />
              </Link>
            </div>
          </div>
          <div className="p-2 ms-auto d-flex flex-row justify-content-md-end justify-content-sm-center">
            {/* <IconButton
              style={{ marginTop: -8, marginRight: 7 }}
              onClick={handleBackward}
            >
              <FastRewindIcon />
            </IconButton> */}
            <AMTDateBox
              date={currentTime.toLocaleString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
              })}
              updateDateTime={updateDateTime}
              defaultDisplayOpt={defaultDisplayOpt}
              defaultTime={defaultTime}
              defaultDate={defaultDate}
            />
            {/* <IconButton
              style={{ marginTop: -8, marginLeft: -7 }}
              onClick={handleForward}
            >
              <FastForwardIcon />
            </IconButton> */}
            <span className="custopm-spacer">
              <IconButton
                style={{ marginTop: -8, marginRight: 7, marginLeft: -10 }}
                onClick={handleRefresh}
              >
                <RefreshIcon />
              </IconButton>
              <IconButton
                style={{ marginTop: -8, marginLeft: -7 }}
                onClick={handleFullScreen}
              >
                <OpenInFullIcon />
              </IconButton>
            </span>
          </div>
        </>
      )}
    </div>
  );
}

DeviceDashboardHeader.propTypes = {
  id: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
  parentRef: PropTypes.any.isRequired,
};

export default DeviceDashboardHeader;
